import i18n from '../../../../../../../i18n'
import {
  NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_NON_REGISTERED_USERS_CHECKBOX,
  NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_RADIO_BUILDINGS,
  NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_REGISTERED_USERS_CHECKBOX,
  NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_TV_SCREENS,
  RecipientAudienceOptionValue,
} from '../../RecipientsField.constants'

export function showBuildingTab(values) {
  return (
    values[NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_RADIO_BUILDINGS] ===
    RecipientAudienceOptionValue.Building
  )
}

export function isActiveBuildingBlock(values) {
  return (
    values[NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_TV_SCREENS] ||
    values[
      NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_NON_REGISTERED_USERS_CHECKBOX
    ] ||
    values[NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_REGISTERED_USERS_CHECKBOX]
  )
}

export function getUserFieldLabel(option) {
  return i18n.t(option.label)
}
